<template>
  <v-avatar
    :size="`${avatarSize}px`"
    tile
    :class="avatarClasses"
  >
    <v-img
      :width="avatarSize"
      :height="avatarSize"
      :class="imageClasses"
      :src="thumbnail"
      @loadstart="handleLoadStart"
      @load="handleLoad"
      @error="handleOnError"
    >
      <template v-slot:placeholder>
        <v-skeleton-loader
          v-if="isLoading"
          :loading="isLoading"
          min-width="100%"
          type="card-avatar"
        ></v-skeleton-loader>
      </template>
    </v-img>
  </v-avatar>
</template>

<script>
const placeholderLink = require('@/assets/loggedPlaceholder96x96.png')
import isStringBase64 from '@/helpers/isStringBase64.js'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ProfilePreviewImage',
  props: {
    profileId: {
      type: [Number, undefined],
      default: undefined,
    },
    uuid: {
      type: [String, undefined],
      default: undefined,
    },
    avatarSize: {
      type: Number,
      default: 48
    },
    imageClasses: {
      type: Array,
      default: () => [],
    },
    avatarClasses: {
      type: Array,
      default: () => [],
    },
    thumbnailUrl: {
      type: String,
      default: ''
    }
  },
  created() {
    if (this.$props.thumbnailUrl) {
      this.setThumbnailUrl(this.$props.thumbnailUrl)
    }

    if (this.$props.profileId === undefined && this.$props.uuid === undefined) {
      if (this.$props.thumbnailUrl) {
        console.warn('No profileId and uuid in profile preview image, but passed thumbnailUrl.')
      } else {
        console.error('No profileId and uuid in profile preview image. Component needs at least one of them.')
      }
    } else {
      if (!this.$props.thumbnailUrl) {
        this.getThumbnailUrl(this.profilePreviews)
      }
    }
  },
  data() {
    return {
      isLoading: true,
      thumbnail: placeholderLink,
      usedPlaceholder: true,
    }
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    ...mapState('userStates', ['user']),
  },
  methods: {
    isStringBase64,
    ...mapActions('profilePreviewsStates', ['addItemsToProfilePreviewQueue','removeItemsInProfilePreviewQueue','getProfilePreviewsDebounced']),
    getThumbnailUrl(profiles) {
      if (this.isLoading || this.usedPlaceholder) {
        const profile = profiles.find(el => this.profileId && el.profileId === this.profileId || this.uuid && el.uuid === this.uuid)
        if (!profile) return;

        this.setThumbnailUrl(profile.thumbnailUrl)
      }
    },
    setThumbnailUrl(thumbnail = '') {
      if (!thumbnail) {
        this.usedPlaceholder = true
        this.thumbnail = placeholderLink
      } else {
        this.usedPlaceholder = false
      }
      if (this.isStringBase64(thumbnail)) {
        if (thumbnail.startsWith('data:image')) {
          this.thumbnail = thumbnail
        } else {
          this.thumbnail = `data:image/png;base64,${thumbnail}`
        }
      } else {
        this.thumbnail = thumbnail
      }
    },
    handleOnError() {
      if (this.profileId || this.uuid) {
        this.isLoading = true
        this.addItemsToProfilePreviewQueue([{ profileId: this.profileId, uuid: this.uuid }])
      } else {
        console.warn('No profile id and uuid in proifle preview image. Component needs at least one of them.')
      }
    },
    handleLoadStart() {
      this.isLoading = true
    },
    handleLoad() {
      if (!this.usedPlaceholder) this.isLoading = false
      if (this.profileId || this.uuid) {
        this.isLoading = true
        this.removeItemsInProfilePreviewQueue([{ profileId: this.profileId, uuid: this.uuid }])
      }
    },
  },
  watch: {
    usedPlaceholder (value) {
      if (value === true && (this.profileId || this.uuid)) {
        this.addItemsToProfilePreviewQueue([{ profileId: this.profileId, uuid: this.uuid }])
      }
    },
    profilePreviews (newProfiles) {
      if (this.isLoading || this.usedPlaceholder) {
        this.getThumbnailUrl(newProfiles)
      }
    },
    user () {
      if (this.user) {
        this.setThumbnailUrl(this.user.thumbnailUrl)
      }
    }
  }
}
</script>

<style lang="scss"></style>
